import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { EpisodioLista } from './EpisodioLista';
import { EpisodioDetalle } from './EpisodioDetalle';

// G: episodios del caso en vista lista (izquierda) y detalle (derecha).
export const CasoEpisodios = ({ caseId, episodios, motivos, loading, seleccionado, onSeleccionar, onCambio, vacio }) => {
  if (loading) return <div className="flex justify-center py-12"><Loader2 className="animate-spin text-slate-400" size={24} /></div>;
  if (!episodios.length) {
    return vacio || (
      <div className="flex flex-col items-center py-12 text-slate-400" data-testid="episodios-vacio">
        <AlertTriangle size={36} className="mb-2 opacity-60" />
        <p>Este caso no tiene episodios de monitores.</p>
      </div>
    );
  }
  const actual = episodios.find((e) => e.id === seleccionado) || episodios[0];
  return (
    <div className="grid gap-5 lg:grid-cols-[minmax(300px,2fr)_5fr]" data-testid="caso-episodios">
      <div className="lg:sticky lg:top-16 lg:self-start">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">{episodios.length} episodios</p>
        <EpisodioLista episodios={episodios} seleccionado={actual.id} onSeleccionar={onSeleccionar} />
      </div>
      <EpisodioDetalle key={actual.id} caseId={caseId} episodio={actual} motivos={motivos} onCambio={onCambio} />
    </div>
  );
};

export default CasoEpisodios;
